import { __extends, __makeTemplateObject, __decorate, __assign as _assign, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize } from '../pvd-utils/enums/size.js';

var SpinnerColor;
(function (SpinnerColor) {
    SpinnerColor["neutral"] = "neutral";
    SpinnerColor["white"] = "white";
})(SpinnerColor || (SpinnerColor = {}));
var DEFAULT_HIDDEN = false;
var DEFAULT_TRIGGERED_BY_INTERACTION = true;
var DEFAULT_SIZE = StandardSize.medium;
var DEFAULT_COLOR = SpinnerColor.neutral;
// Primary and secondary default text provided by the content team
// and adhere to their guidelines
var DEFAULT_PRIMARY_TEXT = 'Loading';
var DEFAULT_SECONDARY_TEXT = 'This could take a moment.';
/**
 * Providence Spinner component.
 * @see {@link https://providence.fmr.com/components/spinner/spinner.html|Spinner documentation}
 */
var PvdSpinner = /** @class */ (function (_super) {
    __extends(PvdSpinner, _super);
    function PvdSpinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._spinnerTabIndex = '-1';
        _this.pvdColor = DEFAULT_COLOR;
        _this.pvdPrimaryText = DEFAULT_PRIMARY_TEXT;
        _this.pvdSecondaryText = DEFAULT_SECONDARY_TEXT;
        _this.pvdSize = DEFAULT_SIZE;
        _this.pvdTriggeredByInteraction = DEFAULT_TRIGGERED_BY_INTERACTION;
        _this.pvdHidden = DEFAULT_HIDDEN;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdSpinner, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdSpinner.prototype, "hasIcon", {
        // #endregion
        // #region private methods
        get: function () {
            return !!this.pvdIcon || this.isSlotUsed('icon');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdSpinner.prototype, "hideMicrocopy", {
        get: function () {
            return this.pvdSize === StandardSize.small;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdSpinner.prototype, "hasSecondaryText", {
        get: function () {
            return !!this.pvdSecondaryText.trim();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdSpinner.prototype, "spinnerContainer", {
        get: function () {
            // getting the top-level container that wraps the component's HTML
            return this.children[0].querySelector(".".concat(PvdSpinner.namespace, "-spinner-root"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdSpinner.prototype, "spinnerDisplay", {
        get: function () {
            return this.pvdInline ? 'inline' : 'block';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdSpinner.prototype, "spinnerRole", {
        get: function () {
            return !this.pvdTriggeredByInteraction ? undefined : 'status';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Focuses into the Spinner's container
     */
    PvdSpinner.prototype.focusSpinnerContainer = function () {
        if (this.spinnerContainer) {
            this.spinnerContainer.focus({ preventScroll: true });
        }
    };
    /**
     * Return focus to the element that triggered the Spinner to display. If
     * the element is no longer on the page, return focus to the body.
     */
    PvdSpinner.prototype.returnFocus = function () {
        if (!this.pvdTriggeredByInteraction) {
            return;
        }
        var target = this._triggeringElement;
        // Previously stored element removed from DOM
        if ((target && !target.isConnected) || !target) {
            target = document.body;
            if (target.hasAttribute('tabindex')) {
                target.setAttribute('tabindex', this._spinnerTabIndex);
            }
        }
        target.focus({ preventScroll: true });
    };
    // #endregion
    // #region LitElement lifecycles
    PvdSpinner.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (!this.pvdTriggeredByInteraction) {
            return;
        }
        if (document.activeElement !== this.spinnerContainer) {
            this._triggeringElement = document.activeElement;
        }
        if (changedProperties.has('pvdHidden')) {
            var prevValue = changedProperties.get('pvdHidden');
            if (prevValue && !this.pvdHidden) {
                // if the Spinner was previously hidden and is now visible, focus into container
                this.focusSpinnerContainer();
            }
            else if (!prevValue && this.pvdHidden) {
                // if the Spinner was previously visible but is now hidden, return focus to last active el
                this.returnFocus();
            }
        }
    };
    PvdSpinner.prototype.disconnectedCallback = function () {
        _super.prototype.disconnectedCallback.call(this);
        this.returnFocus();
    };
    PvdSpinner.prototype.renderIcon = function () {
        return this.scopeTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"], ["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"])), this.pvdIcon, this.pvdSize);
    };
    PvdSpinner.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-spinner-root"),
            modifierPrefix: 'pvd-spinner',
            modifiers: [
                {
                    condition: this.pvdColor !== undefined,
                    className: this.pvdColor,
                },
                {
                    condition: this.pvdInline !== undefined,
                    className: "force-".concat(this.spinnerDisplay),
                },
                {
                    condition: true,
                    className: "".concat(this.pvdSize),
                },
                {
                    condition: this.pvdHidden,
                    className: 'hidden',
                },
            ],
        };
        return x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      <div\n        class=\"", "\"\n        role=\"", "\"\n        tabindex=\"", "\"\n      >\n        <div class=\"pvd-spinner__spinner\" aria-hidden=\"true\">\n          <div class=\"pvd-spinner__visual\">\n            <div class=\"pvd-spinner__mask pvd-spinner__mask--left\">\n              <div class=\"pvd-spinner__mask-inner\"></div>\n            </div>\n            <div class=\"pvd-spinner__mask pvd-spinner__mask--right\">\n              <div class=\"pvd-spinner__mask-inner\"></div>\n            </div>\n          </div>\n        </div>\n\n        ", "\n      </div>\n    "], ["\n      <div\n        class=\"", "\"\n        role=\"", "\"\n        tabindex=\"", "\"\n      >\n        <div class=\"pvd-spinner__spinner\" aria-hidden=\"true\">\n          <div class=\"pvd-spinner__visual\">\n            <div class=\"pvd-spinner__mask pvd-spinner__mask--left\">\n              <div class=\"pvd-spinner__mask-inner\"></div>\n            </div>\n            <div class=\"pvd-spinner__mask pvd-spinner__mask--right\">\n              <div class=\"pvd-spinner__mask-inner\"></div>\n            </div>\n          </div>\n        </div>\n\n        ", "\n      </div>\n    "])), getClassName(classMap), l(this.spinnerRole), this._spinnerTabIndex, this.hideMicrocopy
            ? x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              <div class=\"pvd-spinner__microcopy pvd-spinner__microcopy--screen-reader-only\">\n                ", "\n              </div>\n            "], ["\n              <div class=\"pvd-spinner__microcopy pvd-spinner__microcopy--screen-reader-only\">\n                ", "\n              </div>\n            "])), this.pvdPrimaryText) : x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n              <div class=\"pvd-spinner__microcopy\">\n                <div class=\"pvd-spinner__microcopy-primary\">\n                  ", "\n                  <p class=\"pvd-spinner__microcopy-text\">", "</p>\n                </div>\n\n                ", "\n              </div>\n            "], ["\n              <div class=\"pvd-spinner__microcopy\">\n                <div class=\"pvd-spinner__microcopy-primary\">\n                  ", "\n                  <p class=\"pvd-spinner__microcopy-text\">", "</p>\n                </div>\n\n                ", "\n              </div>\n            "])), this.hasIcon
            ? x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                        <div class=\"pvd-spinner__microcopy-icon\">\n                          <s-slot name=\"icon\"> ", " </s-slot>\n                        </div>\n                      "], ["\n                        <div class=\"pvd-spinner__microcopy-icon\">\n                          <s-slot name=\"icon\"> ", " </s-slot>\n                        </div>\n                      "])), this.renderIcon()) : x(templateObject_4 || (templateObject_4 = __makeTemplateObject([" <s-slot name=\"icon\"></s-slot> "], [" <s-slot name=\"icon\"></s-slot> "]))), this.pvdPrimaryText, !this.hasSecondaryText
            ? ''
            : x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                      <p class=\"pvd-spinner__microcopy-secondary\">", "</p>\n                    "], ["\n                      <p class=\"pvd-spinner__microcopy-secondary\">", "</p>\n                    "])), this.pvdSecondaryText)));
    };
    //#region Component configuration
    PvdSpinner.componentName = 'spinner';
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-color' }, PvdSlotifyBaseComponent.hasChanged(SpinnerColor))),
        __metadata("design:type", String)
    ], PvdSpinner.prototype, "pvdColor", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon' }),
        __metadata("design:type", String)
    ], PvdSpinner.prototype, "pvdIcon", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-inline' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-inline'))),
        __metadata("design:type", Boolean)
    ], PvdSpinner.prototype, "pvdInline", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-primary-text' }),
        __metadata("design:type", String)
    ], PvdSpinner.prototype, "pvdPrimaryText", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-secondary-text' }),
        __metadata("design:type", String)
    ], PvdSpinner.prototype, "pvdSecondaryText", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdSlotifyBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdSpinner.prototype, "pvdSize", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-triggered-by-interaction' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-triggered-by-interaction'))),
        __metadata("design:type", Boolean)
    ], PvdSpinner.prototype, "pvdTriggeredByInteraction", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-hidden' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-hidden'))),
        __metadata("design:type", Boolean)
    ], PvdSpinner.prototype, "pvdHidden", void 0);
    return PvdSpinner;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

export { DEFAULT_COLOR, DEFAULT_HIDDEN, DEFAULT_PRIMARY_TEXT, DEFAULT_SECONDARY_TEXT, DEFAULT_SIZE, DEFAULT_TRIGGERED_BY_INTERACTION, PvdSpinner, SpinnerColor };
